import React from 'react';

import './_media.scss';

class Media extends React.PureComponent {
  getTitle(title) {
    if (title.length === 1) {
      return (
        <div className="title">
          <span>{title[0]}</span>
        </div>
      );
    }
    return (
      <div className="title secondary">
        <span>{title[0]}</span>
        <br className="break" />
        <span className="space">&nbsp;</span>
        <span className="offset">{title[1]}</span>
      </div>
    );
  }

  renderContent() {
    return (
      <div>NOT IMPLEMENTED</div>
    );
  }

  render() {
    return this.renderContent();
  }
}

export default Media;



// WEBPACK FOOTER //
// ./src/components/media/index.js